/* Retire les anciens parfums cadeaux ajoutés automatiquement au panier */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function clean() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null;
        cart.items.forEach(function (l) { if (l.properties && l.properties._gift) { gift = l; } });
        if (!gift) { return false; }
        return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: gift.key, quantity: 0 }) })
          .then(function () { return clean(); });
      })
      .catch(function () { return false; });
  }
  clean().then(function (removed) {
    if (removed !== false) {
      var open = document.querySelector('[data-cg-cart-open]');
      if (open) { open.click(); var close = document.querySelector('.cg-drawer__close'); if (close) { close.click(); } }
    }
  });
})();
